import React from 'react';

export type MaybeLinkProps = React.HTMLAttributes<HTMLElement> & {
  id?: string;
  className?: string;
  href?: string;
};

export default function MaybeLink({ href, children, ...props }: MaybeLinkProps) {
  if (href)
    return (
      <a href={href} {...props}>
        {children}
      </a>
    );

  return <div {...props}>{children}</div>;
}
